import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, Stack, Typography } from "@mui/material";
import { connect } from 'react-redux';
import { Card, CardBody } from "reactstrap";
import CustomTextField from "../../../components/Form/CustomTextField";
import "../../Orders/order.css";

const SEO = ({ setFormValues, values, error }) => {
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [hideSEO, setHideSEO] = useState(false)
  const [editId, setEditId] = useState("")
  const [edit, setEdit] = useState(false)
  const [tempDiscount, setTempDiscount] = useState({
    discount_type: "",
    discount_value: "",
    discount_start_date: "",
    discount_end_date: "",
    min_purchase: "",
    max_purchase: "",
    apply_on_ariba: "",
    apply_on_aspeed: "",
  })

  const [tempDiscountEmpty, setTempDiscountEmpty] = useState({
    discount_type: "",
    discount_value: "",
    discount_start_date: "",
    discount_end_date: "",
    min_purchase: "",
    max_purchase: "",
    apply_on_ariba: "",
    apply_on_aspeed: "",
  })

  const handleDeleteFiles = (id) => {
    const tempFile = values?.discount
    const filteredFIle = tempFile && tempFile.length > 0 && tempFile.filter((x, idx) =>
      id !== idx
    )
    // setSelectedDiscountItem(filteredFIle);
    setFormValues((prevValues) => ({
      ...prevValues,
      discount: filteredFIle
    }))
  }

  const handleEditFiles = (id) => {
    const tempFile = values?.discount
    setEdit(!edit)
    setEditId(id)
    const filteredFIle = tempFile && tempFile.length > 0 && tempFile.filter((x, idx) =>
      id === idx
    )
    setTempDiscount(filteredFIle?.[0])
  }

  const handleSaveEdit = (id) => {
    const tempFile = values?.discount

    setEditId(id)
    const filteredFIle = tempFile && tempFile.length > 0 && tempFile.filter((x, idx) =>
      id !== idx
    )

    setFormValues((prevValues) => {
      const updatedDiscounts = [...prevValues.discount];
      updatedDiscounts[id] = {
        ...updatedDiscounts[id],
        discount_type: tempDiscount?.discount_type,
        discount_value: tempDiscount?.discount_value,
        discount_start_date: tempDiscount?.discount_start_date,
        discount_end_date: tempDiscount?.discount_end_date,
        min_purchase: tempDiscount?.min_purchase,
        max_purchase: tempDiscount?.max_purchase,
        apply_on_ariba: tempDiscount?.apply_on_ariba,
        apply_on_aspeed: tempDiscount?.apply_on_aspeed,
      };

      return {
        ...prevValues,
        discount: updatedDiscounts,
      };
    });
    setTempDiscount({
      discount_type: "",
      discount_value: "",
      discount_start_date: "",
      discount_end_date: "",
      min_purchase: "",
      max_purchase: "",
      apply_on_ariba: "",
      apply_on_aspeed: "",
    })
  }

  const handleAddDiscount = () => {
    let temp = values?.discount
    temp.push(tempDiscountEmpty)
    setFormValues((prevValues) => ({
      ...prevValues,
      discount: temp
    }))

    setTempDiscountEmpty({
      discount_type: "",
      discount_value: "",
      discount_start_date: "",
      discount_end_date: "",
      min_purchase: "",
      max_purchase: "",
      apply_on_ariba: "",
      apply_on_aspeed: "",
    })
  }

  return (
    <React.Fragment>
      <div className="">
        <Card className="p-3 px-2" style={{minHeight: "40vh"}}>
          <CardBody>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <div className="setting-header">SEARCH ENGINE OPTIMIZATION</div>
              <Typography style={{ color: "#7BB9FA", cursor: "pointer", fontSize: "14px" }} onClick={(e) => setHideSEO(!hideSEO)}>{hideSEO ? "Show " : "Hide "} website SEO</Typography>
            </Stack>
            <FormHelperText style={{ color: "#74788DCC" }}>Add a name and description to see how this might appear in a search engine listing.</FormHelperText>
            {
              !hideSEO &&
              <Grid container spacing={2} pt={2}>
                <Grid item xs={12}>
                  <CustomTextField
                    title={'Meta Title'}
                    values={values?.product_meta_title}
                    error={error && error.product_meta_title}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      product_meta_title: e
                    }))}
                    placeholder="Headlines that appears in search entries"
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    title={'Meta keywords'}
                    values={values?.product_meta_keyword}
                    error={error && error.product_meta_keyword}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      product_meta_keyword: e
                    }))}
                    placeholder="Enter relevant keywords separated by commas"
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    title={'Meta Description'}
                    multiline={true}
                    values={values?.product_meta_description}
                    error={error && error.product_meta_description}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      product_meta_description: e
                    }))}
                    rows={4}
                    placeholder="Brief description that appears under the title in search entries"
                  />
                </Grid>
              </Grid>
            }

          </CardBody>
        </Card>
      </div>
    </React.Fragment >
  );
};

function mapStateToProps({ }) {
  return {

  };
}


export default connect(mapStateToProps)(SEO);
